import type { AnalyticsFlightsAndEcsSettingsAddon } from "owa-analytics-types";
import { initializeAnalyticsFlightsAndAppSettings } from "./initialization/initializeAnalyticsFlightsAndAppSettings";

export function analyticsSettingsFlightsAndEcsSettingsAddon(): AnalyticsFlightsAndEcsSettingsAddon {
    return {
        initializeAnalyticsFlightsAndAppSettings,
    };
}
